import {Button} from "../components/Button";
import React from "react";
import styled from "styled-components";
import {useAppContext} from "../provider/AppProvider";
import {getSizeForLayout} from "../utils/getSizeForLayout";
import background from './../assets/settings_background.jpg';
import {useViewPortState} from "../provider/ResizeProvider";

const Root = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    height: 100%;
`;

const Image = styled.img`
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    width: 300px;
    height: 300px;
    z-index: -1;
    filter: sepia(0.4);
    border-radius: 10px;
    object-fit: fill;

    @media (min-width: 768px) {
        width: 450px;
        height: 450px;
    }

    @media (min-width: 1024px) {
        width: 600px;
        height: 600px;
    }

    -webkit-user-select: none; /* Safari */
    -webkit-touch-callout: none; /* iOS Safari */
    -webkit-tap-highlight-color: transparent;

    pointer-events: none; /* Prevent any interactions */
    user-drag: none; /* Disable image dragging */
    -webkit-user-drag: none; /* Disable image dragging for Safari */
`;

const ButtonWrapper = styled.div`
    width: 140px;

    @media (min-width: 768px) {
        width: 200px;
    }

    @media (min-width: 1024px) {
        width: 350px;
    }
`;

const MainButtons = styled.div`
    display: flex;
    margin-top: 45px;
    flex-direction: column;
    gap: 10px;
`;

const OptionalButtons = styled.div`
    margin-top: 52px;
    display: flex;
    gap: 8px;
`;

const HintButton = styled.div`
    position: absolute;
    top: 16px;
    right: 16px;
`;

interface Props {
    restart?: () => void;
    setShowLeaderBord: React.Dispatch<React.SetStateAction<boolean>>;
    onShowHint?: (p: boolean) => void;
}

export const DefaultButtonMenu = ({restart, setShowLeaderBord, onShowHint}: Props) => {
    const {isDesktopState, isTableState} = useViewPortState();
    const {onSwitchSound, sound, setScreen, onSwitchSettings, screen, translate, mode} = useAppContext();
    const goToHome = () => {
        setScreen('start', mode);
        onSwitchSettings();
    }

    const toggleLeaderBord = () => {
        setShowLeaderBord(prev => !prev);
    }

    return (
        <Root>
            <Image src={background}/>
            <MainButtons>
                <ButtonWrapper>
                    <Button text={translate.continue} onClick={onSwitchSettings}/>
                </ButtonWrapper>
            </MainButtons>
            <OptionalButtons>
                <Button onClick={toggleLeaderBord} iconName='leaderBord' size={getSizeForLayout({m: 30, t: 45, d: 80, isTable: isTableState, isDesktop: isDesktopState})} color='#1c188c'/>
                <Button onClick={onSwitchSound} iconName={sound ? 'soundOn' : 'soundOff'} size={getSizeForLayout({m: 30, t: 45, d: 80, isTable: isTableState, isDesktop: isDesktopState})}
                        color='#1c188c'/>
                {screen === 'game' && !!restart && (
                    <Button
                        onClick={() => {
                            restart();
                            onSwitchSettings();
                        }}
                        iconName='retry'
                        size={getSizeForLayout({m: 30, t: 45, d: 80, isTable: isTableState, isDesktop: isDesktopState})}
                        color='#1c188c'/>
                )}
                {screen === 'game' && <Button onClick={goToHome} iconName='home' size={getSizeForLayout({m: 30, t: 45, d: 80, isTable: isTableState, isDesktop: isDesktopState})} color='#1c188c'/>}
            </OptionalButtons>
            <HintButton>
                {screen === 'game' && (
                    <Button onClick={() => {
                        onSwitchSettings();
                        onShowHint?.(true);
                    }} iconName='question' size={getSizeForLayout({m: 30, t: 45, d: 80, isTable: isTableState, isDesktop: isDesktopState})} color='#1c188c'/>
                )}
            </HintButton>
        </Root>
    )
}
